export const trimString = (text: string | null, maxLength: number) => {
  return text && text.length > maxLength ? text.slice(0, maxLength) + '...' : text
}



// WEBPACK FOOTER //
// ./src/utils/stringV2.ts